declare const jQuery: any;
const $ = jQuery;

export function initMainMenuPopup(): void
{
    const $menu = $(".popup-main-menu ul.menu");
    if ($menu.length === 0)
    {
        return;
    }
    const $clonedMenu = $menu.clone().empty().attr("id", $menu.attr("id") + "-2").insertAfter($menu);
    const $items = $menu.children("li");
    const numItemsPerMenu: number = Math.round($items.length / 2);
    $items.slice(numItemsPerMenu).appendTo($clonedMenu);
}
